<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>
<p-fieldset>
    <ng-template pTemplate="header">{{translations.lbl_workshop}}</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="redirectWorkShop()"></button>

        </ng-template>

    </p-toolbar>

    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{translations.lbl_church_name}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null ?
                        workShopDetail.chr.name : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_workshop}}</span>
                    <span class="p-text-bold">{{workShopDetail != null ? workShopDetail.wst.wsName : ""}} </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{translations.lbl_schedule}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null ?
                        workShopDetail.f0.fromTime : ""}} -
                        {{workShopDetail != null && workShopDetail.f0 != null ? workShopDetail.f0.toTime : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Part 1a/2a</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null ?
                        workShopDetail.f0.partN2s : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>Part Desierto</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null?
                        workShopDetail.f0.partN15s : ""}}</span>
                </div>
            </p-panel>
        </div>
    </div>

    <p-table [columns]="cols" [value]="sessions" editMode="row" dataKey="session" [rows]="6" [paginator]="true"
    currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"  [showCurrentPageReport]="true"
        styleClass="p-datatable-responsive-demo">
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{sessions ? sessions.length : 0}}
                {{translations.lbl_records}}
            </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr class="tableHeaderRow"> 
                <th *ngFor="let col of columns" class="tableHeader">
                    <div class="rotate">
                        {{col.shortName}}
                    </div>
                </th>
                <th style="width:8rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-sessions let-columns ="columns" let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="sessions">
                <td *ngFor="let col of columns">
                    <div *ngIf="col.id != 'session'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-checkbox [(ngModel)]="sessions[col.id].isAssist"
                                    binary="true" inputId="binary">
                                </p-checkbox>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <i class="pi" [ngClass]="{
                                    'pi-check-circle true-icon': sessions[col.id].isAssist,
                                    'pi-times-circle false-icon': !sessions[col.id].isAssist
                                  }"></i>
                            </ng-template>
                        </p-cellEditor>
                    </div>
                    <div *ngIf="col.id == 'session'" >
                        {{sessions[col.id]}}
                    </div>
                </td>
                <td style="display:flex;justify-content: end;">
                    <button *ngIf="!editing" pButton pRipple type="button"
                        pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(sessions)"
                        class="p-button-rounded p-button-warning p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                        (click)="onRowEditSave(sessions, ri)"
                        class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                        (click)="onRowEditCancel(sessions)"
                        class="p-button-rounded p-button-text p-button-danger"></button>
                </td>
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="footer" let-sessions let-columns="columns">
            <tr>
                <td colspan="2" class="p-text-right">Totals</td>
                <td *ngFor="let total of totalList">
                    {{total.isAssist}}
                </td>
            </tr>
        </ng-template> -->
    </p-table>

</p-fieldset>